import { createAction, props } from '@ngrx/store';
import {
  CreateUserModel,
  ProductCodes,
  ProductModel,
} from '../../models/user-profile.model';
import { UserProfileModel } from '../../models/user-profile.model';
import { CreateUserErrors } from './user-session.state';

export const login = createAction(
  '[Login Page] Login',
  props<{ username: string; password: string }>(),
);

export const loginError = createAction('[Auth API] Login Error');

export const logout = createAction(
  '[Header Menu] Logout',
  props<{ isTimedOut: boolean }>(),
);

export const logoutSuccess = createAction(
  '[Auth API] Logout Success',
  props<{ isTimedOut: boolean }>(),
);

export const logoutError = createAction('[Auth API] Logout Error');

export const dismissAlert = createAction('[Login Page] Dismiss Alert Message');

export const getSession = createAction('[User Session Effects] Get Session');

export const getSessionSuccess = createAction(
  '[Auth API] Get Session Success',
  props<{ userData: UserProfileModel }>(),
);

export const getSessionError = createAction('[Auth API] Get Session Error');

export const createUser = createAction(
  '[Pairing Page Create User Form Component] Create User',
  props<{ userData: CreateUserModel; token: string }>(),
);

export const createUserError = createAction(
  '[Auth API] Create User Error',
  props<{ errors: CreateUserErrors }>(),
);

export const authenticateAndPair = createAction(
  '[Pairing Page Pairing Form Component] Create User',
  props<{ username: string; password: string; token: string }>(),
);

export const completePairingSuccess = createAction(
  '[Home Page] Complete External Pairing Success',
);

export const completePairingError = createAction(
  '[Home Page] Complete External Pairing Error',
);

export const pairProduct = createAction(
  '[Home Page] Pair Product',
  props<{ productCode: ProductCodes }>(),
);

export const pairProductSuccess = createAction(
  '[Auth API] Pair Product Success',
);

export const pairProductError = createAction('[Auth API] Pair Product Error');

export const unpairProduct = createAction(
  '[Home Page] Unpair Product',
  props<{ product: ProductModel }>(),
);

export const unpairProductSuccess = createAction(
  '[Auth API] Unpair Product Success',
  props<{ productCode: ProductCodes }>(),
);

export const unpairProductError = createAction(
  '[Auth API] Unpair Product Error',
);

export const switchToProduct = createAction(
  '[Home Page] Switch To Product',
  props<{ product: ProductModel; isRedirect?: boolean }>(),
);

export const switchToProductSuccess = createAction(
  '[Auth API] Switch To Product Success',
);
